export default "__VITE_ASSET__BgNtmgjp__"